
import {createRouter, createWebHistory} from 'vue-router';


const router = createRouter({
    history: createWebHistory("/"),
    routes: [
        {
            path: "",
            component: ()=> import('../components/LoginPage.vue')
        },
        {
            path: "/dashboard",
            component: ()=> import('../components/dashboard/MainDashboard.vue'),
            children: [
                {
                    path: "",
                    component: ()=> import('../components/dashboard/pages/Home.vue')
                },
                {
                    path: "users",
                    component: ()=> import('../components/dashboard/pages/User.vue')
                },
                {
                    path: "devicelists",
                    component: ()=> import('../components/dashboard/pages/DeviceList.vue')
                },
                {
                    path: "devices",
                    component: ()=> import('../components/dashboard/pages/Devices.vue')
                },
                {
                    path: "devices/:imei",
                    component: ()=> import('../components/dashboard/pages/DeviceDetail.vue')
                }
            ]
        }
    ]
});

export default router;